import React, { useEffect } from "react";
import {
  Button,
  ContentSection,
  InstructionStepper,
} from "@vwfs-bronson/bronson-react";
import { Output } from "../../Text";
import { trackButton, trackPage } from "./SignatureSuccessTracking"
import BasicSection from './common/BasicSection';
import Heading from './common/Heading';
import AuthorizeAndGetVehicle from './common/AuthorizeAndGetVehicle';
import MarketingCards from '../../components/MarketingCards/MarketingCards';

const SignatureSuccessPageHEYCAR = ({ shoppingCart, redirectUrl, prefill }) => {

  const originSystem = prefill?.salesChannel?.originSystem;
  const manufacturer = prefill?.vehicleData?.model?.manufacturer;
  
  useEffect(() => {
    trackPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderStepper = () => (
    <InstructionStepper className="u-mt-large" small>
      <InstructionStepper.Step
        key="0"
        icon={Output.resolve(`pages.signatureSuccess.${originSystem}.stepper.step1.icon`)}
        title={Output.resolve(`pages.signatureSuccess.${originSystem}.stepper.step1.text`)}
      />
      <InstructionStepper.Step
        key="2"
        icon={Output.resolve(`pages.signatureSuccess.${originSystem}.stepper.step2.icon`)}
        title={Output.resolve(`pages.signatureSuccess.${originSystem}.stepper.step2.text`)}
      />
    </InstructionStepper>
  )

  const handleRedirect = () => {
    window.open(redirectUrl, "_blank");
    trackButton(originSystem);
  };

  return (
    <>
      <ContentSection pageWrap>
        <Heading
          originSystem={originSystem}
          shoppingCart={shoppingCart}
          stepper={renderStepper()}
        />
        <div className="u-mt-large">
          <BasicSection
            section="getAndSaveDocuments"
            originSystem={originSystem}
          />
        </div>
        <div className="u-mt-large">
          <AuthorizeAndGetVehicle
            originSystem={originSystem}
            prefill={prefill}
            buttons={
              <>
                <Button
                  className="appFixedButton"
                  onClick={handleRedirect}
                  disabled={!redirectUrl}
                >
                  {Output.resolve(
                    `pages.signatureSuccess.${originSystem}.authorizeAndGetVehicle.button.text`
                  )}
                </Button>
              </>
            }
          />
        </div>
        <div className="u-mt-large">
          <MarketingCards
            manufacturer={manufacturer}
            originSystem={originSystem}
          />
        </div>
      </ContentSection>
    </>
  );
};

export default SignatureSuccessPageHEYCAR;
